import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import i18n from '../../i18n';

/**
 * Structure-shaped loading placeholders for the hot pages — the page frame appears
 * immediately and content fades in, instead of a centered full-page spinner.
 *   tiles  — dashboard stat-tile grid
 *   rows   — list pages (clients / reviews tables)
 *   detail — detail panes (header + content blocks)
 */
export function PageSkeleton({ variant }: { variant: 'tiles' | 'rows' | 'detail' }) {
  if (variant === 'tiles') {
    return (
      <Skeleton aria-label={i18n.t('shell.loadingDashboard')}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, padding: 16 }}>
          {Array.from({ length: 4 }, (_, i) => <SkeletonItem key={i} style={{ height: 96 }} />)}
        </div>
        <div style={{ padding: 16 }}><SkeletonItem style={{ height: 240 }} /></div>
      </Skeleton>
    );
  }
  if (variant === 'rows') {
    return (
      <Skeleton aria-label={i18n.t('shell.loadingList')}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: 16 }}>
          {Array.from({ length: 8 }, (_, i) => <SkeletonItem key={i} style={{ height: 36 }} />)}
        </div>
      </Skeleton>
    );
  }
  return (
    <Skeleton aria-label={i18n.t('shell.loadingDetails')}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 16 }}>
        <SkeletonItem style={{ height: 32, width: '40%' }} />
        <SkeletonItem style={{ height: 120 }} />
        <SkeletonItem style={{ height: 120 }} />
      </div>
    </Skeleton>
  );
}
